import { apiFetch } from "@/api/client";
import type {
  FastFeedBuyerRow,
  FastFeedDailyRow,
  FastFeedPurchaseRow,
  FastFeedSeriesRow,
  FastFeedSummary,
} from "@/api/types";
import { queryOptions } from "@tanstack/react-query";

export const fastFeedSummaryQuery = queryOptions({
  queryKey: ["fast-feed", "summary"],
  queryFn: () => apiFetch<FastFeedSummary>("/api/v1/fast-feed/summary"),
  staleTime: 60_000,
});

export function fastFeedDailyQuery(range: string) {
  return queryOptions({
    queryKey: ["fast-feed", "daily", range],
    queryFn: () =>
      apiFetch<{ data: FastFeedDailyRow[] | null }>(`/api/v1/fast-feed/daily?range=${range}`).then(
        (r) => r.data ?? [],
      ),
    staleTime: 60_000,
  });
}

export function fastFeedBuyersQuery(limit = 50) {
  return queryOptions({
    queryKey: ["fast-feed", "buyers", limit],
    queryFn: () =>
      apiFetch<{ data: FastFeedBuyerRow[] | null }>(`/api/v1/fast-feed/buyers?limit=${limit}`).then(
        (r) => r.data ?? [],
      ),
    staleTime: 120_000,
  });
}

export function fastFeedSeriesQuery(granularity: "H" | "D" | "W" | "M") {
  return queryOptions({
    queryKey: ["fast-feed", "series", granularity],
    queryFn: () =>
      apiFetch<{ data: FastFeedSeriesRow[] | null }>(
        `/api/v1/fast-feed/series?granularity=${granularity}`,
      ).then((r) => r.data ?? []),
    staleTime: 120_000,
  });
}

export function fastFeedPurchasesQuery(limit = 100) {
  return queryOptions({
    queryKey: ["fast-feed", "purchases", limit],
    queryFn: () =>
      apiFetch<{ data: FastFeedPurchaseRow[] | null }>(
        `/api/v1/fast-feed/purchases?limit=${limit}`,
      ).then((r) => r.data ?? []),
    staleTime: 60_000,
  });
}
